<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="pointsOfSale"
          v-model:page="page"
          v-model:items-per-page="perPage"
          :items-length="totalItems"
          :items-per-page-options="[
            { value: 5, title: '5' },
            { value: 10, title: '10' },
            { value: 20, title: '20' },
            { value: 30, title: '30' },
            { value: 40, title: '40' },
            { value: 50, title: '50' },
          ]"
          :loading="isLoading"
        >
          <template v-slot:item.last_communication="{ item }">
            <span>
              {{ formatLastCommunication(item.last_communication) }}
            </span>
          </template>
          <template v-slot:item.sat="{ item }">
            <span>
              {{ item.sats?.[0]?.serial_number ?? "-" }}
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import { usePOSQuery } from "@/queries/modules/pos";
import { useSnackbar } from "@/plugins/snackbar";
import { useDateFormat } from "@/composables/useDateFormat";
import { useMetaStore } from "@/stores/meta";

const snackbar = useSnackbar();
const { formatUtcToLocal } = useDateFormat();
const metaStore = useMetaStore();

// Set page title
metaStore.setTitle("PDVs");

// Pagination state
const page = ref(1);
const perPage = ref(10);

// Table headers (Vuetify 3 format)
const headers = [
  { title: "Nome", key: "name" },
  { title: "Descrição", key: "description" },
  { title: "MAC", key: "mac_address" },
  { title: "Serial do Sat", key: "sat" },
  { title: "Última Comunicação", key: "last_communication" },
];

// Query params - reactive to pagination changes
const queryParams = computed(() => ({
  page: page.value,
  per_page: perPage.value,
}));

// Use TanStack Query for POS data
const { data: posData, isLoading, error } = usePOSQuery(queryParams);

// Computed properties
const pointsOfSale = computed(() => posData.value?.items || []);
const totalItems = computed(() => posData.value?.total || 0);

// Format date helper
const formatLastCommunication = (date) => {
  if (!date) return "-";
  return formatUtcToLocal(date);
};

// Watch for errors
watch(error, (err) => {
  if (err) {
    snackbar.error("Ocorreu um erro ao listar os PDV's!");
  }
});
</script>

<style scoped></style>
